export const authMixin = {
  methods: {
    userHaveRole (role) {
      return this.$store.getters.getRolesList.some(itm => itm === role)
    }
  }
}
